(function () {
	"use strict";
	angular.module("cardFrontConsumer.areas.faqs", []);
}());